import { createFileRoute } from "@tanstack/react-router"
import NoosTriggersTab from "~/components/noos-supply-plan/NoosTriggersTab"
import { isTriggerReason, type TriggerReason } from "~/components/noos-supply-plan/triggerReasons"
import { usePageTracking } from "~/hooks/usePageTracking"

type TriggersSearch = { reason?: TriggerReason }

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers",
)({
  validateSearch: (search: Record<string, unknown>): TriggersSearch => ({
    reason: isTriggerReason(search.reason) ? search.reason : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan Detail - Triggers")
  const { reason } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <NoosTriggersTab
      reason={reason}
      onReasonApplied={() =>
        void navigate({ search: (prev) => ({ ...prev, reason: undefined }), replace: true })
      }
    />
  )
}
